import { FartPlayerAgent } from "./FartPlayerAgent";
import { VisualRenderingAgent } from "./VisualRenderingAgent";
import { UIManager } from "./UIManager";

export class AppOrchestrator {
	private fartPlayer: FartPlayerAgent;
	private visualRenderer: VisualRenderingAgent;
	private uiManager: UIManager;
	private unsubscribe?: () => void;

	constructor() {
		// Create canvas element
		const canvas = document.createElement("canvas");
		canvas.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
      z-index: 10;
    `;
		document.body.appendChild(canvas);

		// Instantiate agents
		this.fartPlayer = new FartPlayerAgent();
		this.visualRenderer = new VisualRenderingAgent(canvas, () =>
			this.fartPlayer.togglePlayback(),
		);

		const root = document.getElementById("root");
		if (!root) {
			throw new Error("Root element not found");
		}
		this.uiManager = new UIManager(root);
	}

	async initialize() {
		// Initialize fart player (async operation)
		await this.fartPlayer.initialize();

		// Subscribe to player state changes
		this.unsubscribe = this.fartPlayer.subscribe(() =>
			this.handleStateChange(),
		);

		// Initial render
		this.handleStateChange();
	}

	private handleStateChange() {
		// Update visual renderer
		this.visualRenderer.updateAudioData(this.fartPlayer.audioData);
		this.visualRenderer.setPlaying(this.fartPlayer.isPlaying);

		// Update UI
		this.uiManager.render({
			isPlaying: this.fartPlayer.isPlaying,
			isLoading: this.fartPlayer.isLoading,
			error: this.fartPlayer.error,
		});
	}

	destroy() {
		this.unsubscribe?.();
		this.fartPlayer.destroy();
		this.visualRenderer.destroy();
		this.uiManager.destroy();
	}
}
